const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ITS_REGEX = /^\d{8}$/;
const MOBILE_REGEX = /^03\d{9}$/;

export function formatItsInput(value) {
    if (value == null || value === '') return '';
    return String(value).replace(/\D/g, '').slice(0, 8);
}

export function formatMobileInput(value) {
    if (value == null || value === '') return '';
    let digits = String(value).replace(/\D/g, '');
    if (digits.length > 0 && !digits.startsWith('03')) {
        if (digits.startsWith('3')) {
            digits = '0' + digits;
        } else if (!digits.startsWith('0')) {
            digits = '03' + digits;
        }
    }
    return digits.slice(0, 11);
}

export function formatEmailInput(value) {
    if (value == null || value === '') return '';
    return String(value).trim().toLowerCase();
}

export const memberValidations = {
    itsId: [
        (val) => !!val || 'Its number is required',
        (val) => ITS_REGEX.test(String(val)) || 'Its number must be exactly 8 digits',
    ],
    hofId: [
        (val) => !!val || 'HOF Its number is required',
        (val) => /^\d+$/.test(String(val)) || 'HOF Its number must be numeric',
    ],
    sfNo: [
        (val) => !!val || 'SF number is required',
    ],
    fullName: [
        (val) => !!(val && String(val).trim()) || 'Full name is required',
    ],
    section: [
        (val) => !!val || 'Section is required',
    ],
    mobileNo: [
        (val) => !!val || 'Mobile number is required',
        (val) => MOBILE_REGEX.test(String(val)) || 'Mobile must be in format 03xxxxxxxxx',
    ],
    email: [
        (val) => !!val || 'Email is required',
        (val) => EMAIL_REGEX.test(String(val)) || 'Enter a valid email address',
    ],
};
